module.exports = __webpack_public_path__ + "img/logo_r.7be45422.png";